/* @flow */

import { type BaseChart } from '../types';

const options = (baseChart: BaseChart) => ({
    height: 250,
    legend: { position: 'none' },
    hAxis: {
        slantedText: true,
        slantedTextAngle: 30,
    },
    vAxis: {
        title: baseChart.coluna[1],
    },
});

const graficoDeLinhas = (baseChart: BaseChart) => {
    const html = document.getElementById(baseChart.id);
    const base = new global.google.visualization.DataTable();
    base.addColumn('string', baseChart.coluna[0]);
    base.addColumn('number', baseChart.coluna[1]);
    base.addRows(baseChart.resultado);

    const chart = new global.google.visualization.AreaChart(html);
    chart.draw(base, options(baseChart));
};

export default graficoDeLinhas;
